module.exports = __webpack_public_path__ + "img/icon_footer_sport_football_selected.2df8ce8b.png";